import { lazy, type ComponentType, type LazyExoticComponent, type ReactElement } from "react";
import type { RouteObject } from "react-router-dom";
import { STATIC_COURSE_ASSIGN_BROWSER_ROUTES } from "./browser.routes";

const CourseAssignPage = lazy(() => import("../pages/CourseAssign"));
const SpecialInitiativeCoursesPage = lazy(() => import("../pages/SpecialInitiativeCourses"));

type WithSuspense = (component: LazyExoticComponent<ComponentType>) => ReactElement;

export function getStaticCourseAssignRoutes(withSuspense: WithSuspense): RouteObject[] {
	return [
		{
			path: STATIC_COURSE_ASSIGN_BROWSER_ROUTES.SPECIAL_INITIATIVE,
			element: withSuspense(SpecialInitiativeCoursesPage),
		},
		{ path: STATIC_COURSE_ASSIGN_BROWSER_ROUTES.COURSE_ASSIGN, element: withSuspense(CourseAssignPage) },
	];
}
